// extracted by mini-css-extract-plugin
export default {"screen":"StreakScreenRedesign_screen__DGWzB","continue":"StreakScreenRedesign_continue__Ne14Y"};